var TrackingEvent;
(function (TrackingEvent) {
    TrackingEvent["ReferralProjectSubmitted"] = "Referral Project Submitted";
    TrackingEvent["ReferralLinkClicked"] = "Referral Link Clicked";
    TrackingEvent["ProjectClicked"] = "Project Clicked";
    TrackingEvent["ProviderClicked"] = "Provider Clicked";
    TrackingEvent["ProviderContactClicked"] = "Provider Clicked";
    TrackingEvent["GrantApplyNowClicked"] = "Grant Apply Now Click";
    TrackingEvent["ALCGrantValidationCtaClicked"] = "ALC Grant Validation CTA Clicked";
    TrackingEvent["OnboardingStarted"] = "Onboarding Started";
    TrackingEvent["OnboardingStepCompleted"] = "Onboarding Step Completed";
    TrackingEvent["OnboardingCompleted"] = "Onboarding Completed";
    TrackingEvent["CheckoutPlansViewed"] = "Checkout Plans Viewed";
    TrackingEvent["OpenMeetingModalClicked"] = "Open Meeting Modal Clicked";
    TrackingEvent["ButtonClicked"] = "Button Clicked";
    TrackingEvent["WebsiteButtonClicked"] = "Website Button Clicked";
    TrackingEvent["WebsiteHeaderTabClicked"] = "Website Header Tab Clicked";
})(TrackingEvent || (TrackingEvent = {}));
export default TrackingEvent;
